<template>
  <v-container fluid py-0>
    <v-layout row wrap>
      <v-flex xs12 sm3>
        <p class="my-0">{{$t('average')}}</p>
        <v-radio-group v-model="type" row class="my-0">
          <v-radio v-if="matchType != 'user'" :label="$tc('match')" value="match" color="primary"></v-radio>
          <v-radio
            v-if="match && match.tournamentId"
            :label="$tc('tournament')"
            value="tournament"
            color="primary"
          ></v-radio>
          <v-radio :label="$tc('act')" value="act" color="primary"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex v-if="matchType == 'team'" d-flex xs12 md3 px-2>
        <v-autocomplete
          :items="listTeams"
          :label="$t('select', {field: $tc('team')})"
          v-model="teamId"
        ></v-autocomplete>
      </v-flex>
      <v-flex align-self-center px-2>
        <v-btn
          @click="getStats"
          :loading="loading"
          class="ma-0"
          color="primary"
          small
        >{{$t('search')}}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <template v-if="show">
        <v-flex d-flex xs12 pa-2 v-for="(stat, index) of localStats" :key="index + 1100">
          <bar-chart :title="stat.title" :data="stat.stats"></bar-chart>
        </v-flex>
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import BarChart from '@/components/widgets/chart/BarChart'
import DonutChart from '@/components/widgets/chart/DonutChart'
import { dateFormat } from '@/helpers/dateHelper'
import queueToast from '@/helpers/queueToast'

export default {
  name: 'tabStats',
  components: { BarChart, DonutChart },
  props: {
    matchType: {
      type: String,
      required: true,
      default: ''
    },
    canScore: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      type: 'act',
      userId: '',
      teamId: '',
      show: true
    }
  },
  mounted() {
    this.setClear()
  },
  watch: {
    match(val) {
      this.setClear()
    },
    localStats() {
      this.show = false
      let vm = this
      setTimeout(() => {
        vm.show = true
      }, 200)
    }
  },
  computed: {
    ...mapState({
      match: state => state.matches.matchSelected,
      loading: state => state.stats.loading,
      listSelectTeams: state => state.teams.listSelectTeams
    }),
    ...mapGetters({
      averageStats: 'stats/averageStats',
      matchesStats: 'stats/matchesStats',
      matchesStatsByAct: 'stats/matchesStatsByAct',
      matchesStatsByTournament: 'stats/matchesStatsByTournament'
    }),

    localStats() {
      let localStats = []
      if (this.type == 'act') {
        localStats = this.matchesStatsByAct
      } else if (this.type == 'match') {
        localStats = this.matchesStats
      } else if (this.type == 'tournament') {
        localStats = this.matchesStatsByTournament
      }

      return localStats
    },
    listUsers() {
      let users = []
      return users
    },
    listTeams() {
      if (!this.match || this.matchType != 'team') return []
      let teams = []
      if (this.match.homeTeamId)
        teams.push({
          value: this.match.homeTeamId,
          text: this.match.homeTeam || ''
        })
      if (this.match.visitorTeamId)
        teams.push({
          value: this.match.visitorTeamId,
          text: this.match.visitorTeam || ''
        })
      if (this.canScore) return teams

      return this.listSelectTeams.filter(item =>
        teams.some(team => team.value == item.value)
      )
    }
  },
  methods: {
    ...mapActions({
      setAverages: 'stats/setAverages',
      setClear: 'stats/setClear'
    }),
    getStats() {
      if (!this.validate()) return

      this.setClear()
      let params = {}
      params.matchId = this.match._id

      if (this.matchType == 'team') {
        params.teamId = this.teamId
      } else if (this.matchType == 'user') {
        params.userId = this.match.user
      }

      this.setAverages(params)
    },
    validate() {
      let error = false
      let messages = []

      if (!this.match || !this.match._id) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('match') }))
      }
      if (this.matchType == 'team' && !this.teamId) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('team') }))
      }
      if (this.matchType == 'user' && !this.match.user) {
        error = true
        messages.push(this.$t('error.required', { field: this.$tc('user') }))
      }

      if (error) {
        queueToast(messages)
        return
      }
      return !error
    }
  }
}
</script>
